import AppointmentPatientSelectPage from "./AppointmentPatientSelectPage";

export default AppointmentPatientSelectPage;

export * from "./AppointmentPatientSelectPage";
